import { z } from 'zod';

export const PlayerSurveyFormSchema = 
z.object({
	comment: z.string().min(1, 'lbl_SabaSurveyRequired').min(10, 'lbl_GSabaSurveyCharactersLess').max(1000, 'lbl_GSabaSurveyCharactersMore'),
	loveScore: z.number().min(1, 'lbl_SabaSurveyRequired'),
	recommendScore: z.number().min(1, 'lbl_SabaSurveyRequired'),
	recommendOptions: z.string().min(1, 'lbl_SabaSurveyRequired'),
	otherRecommendComment: 
	z.string().max(200, 'lbl_GSabaSurveyCharactersBetween01'),
}).refine((data) => {
	const checkedOther = data.recommendOptions.includes('7') || data.recommendOptions.includes('14')
	const hasValue = data.otherRecommendComment.length > 0;

	if (checkedOther && !hasValue) {
		return false;
	} else {
		return true;
	}
}, {
	message: 'lbl_SabaSurveyRequired',
	path: ['otherRecommendComment']
});

export type PlayerSurveyDataInputs = z.infer<typeof PlayerSurveyFormSchema>;
